var hasAccess = true;

export const setAccess = (access) => {
    hasAccess = access;
}

export const getAccess = () => {
    return hasAccess;
}
